var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C14.4288 0 18.1851 2.87899 19.4996 6.86752L19.4037 6.90562C14.4946 8.85755 11.9512 14.308 13.6092 19.3289C12.4896 19.7623 11.2726 20 10 20C5.53156 20 1.74765 17.0692 0.465693 13.025L0.583604 12.9844C5.7291 11.2127 8.49937 5.6613 6.85915 0.503197C7.84689 0.176701 8.90281 0 10 0ZM0.218868 12.0906C0.0754586 11.4164 0 10.717 0 10C0 5.91156 2.45353 2.39617 5.96852 0.845908C7.41422 5.49765 4.86548 10.4968 0.228151 12.0936L0.218868 12.0906ZM19.7551 7.7908C19.9154 8.5015 20 9.24087 20 10C20 13.9104 17.7555 17.2966 14.4844 18.9406C13.044 14.4231 15.344 9.54504 19.7551 7.7908Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall);
export default __webpack_public_path__ + "static/media/ball.90f3962de401424bb4797d63efdead31.svg";
export { ForwardRef as ReactComponent };